import axios from "axios";
import Swal from "sweetalert2";

export const getCategories = async (store_id ,section_id ,store_only_id ,search ,page) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/categories",    
        {
          params:{
store_id ,
section_id ,
page,
store_only_id,
search

          },
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
  export const showCategories = async (id ,lang) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        `/v1/admin/categories/${id}`,    
        {

          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

  export const storeCategories = async (postData) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/categories", postData,   
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
    export const updateCategories = async (postData,id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        `/v1/admin/categories/${id}`, postData,   
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

      export const deleteCategories = async (id,lang) => {
      const brear = localStorage.getItem("token");
      const result = await Swal.fire({
        title: "هل انت متأكد ؟",
        text: "سيتم الحذف",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Okay",
      });
      if (result.isConfirmed) {
        try {
          const { data } = await axios.delete(`/v1/admin/categories/${id}`, { headers:{
  Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang,
          }
          
          });
          if (data.success === true) {
            Swal.fire("Deleted!", `${data.message}`, "success");
          } else {
            Swal.fire("Not deleted", `${data.message}`, "info");
          }
          return data;
        } catch (error) {
          throw error;
        }
      }
    };